import * as React from 'react';
// mui
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent
} from '@mui/lab';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import {
  Paper,
  Typography,
  useTheme,
  Box,
  useMediaQuery
} from '@mui/material';
// icons
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import BuildIcon from '@mui/icons-material/Build';
import SendToMobileIcon from '@mui/icons-material/SendToMobile';
import InsightsIcon from '@mui/icons-material/Insights';
import EventIcon from '@mui/icons-material/Event';

export default function RoadmapTimeline() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const roadmap = [
    {
      title: 'Alpha Launch',
      date: 'Q2 2025',
      description: 'Release the first stable version with core task management and suggestion algorithm.',
      icon: <RocketLaunchIcon />
    },
    {
      title: 'Mobile Compatibility',
      date: 'Q2 2025',
      description: 'Release a mobile compatibile version.',
      icon: <SendToMobileIcon />
    },
    {
      title: 'User Feedback Integration',
      date: 'Q2 2025',
      description: 'Gather user insights, improve UX, and refine the smart suggestion engine.',
      icon: <InsightsIcon />
    },
    {
      title: 'Beta Launch',
      date: 'Q2 2025',
      description: 'Release a more refined version across multiple platforms with a suite of new features.',
      icon: <RocketLaunchIcon />
    },
    {
      title: 'Team Collaboration Tools',
      date: 'Q2 2025',
      description: 'Add shared task boards, team priorities, and role-based permissions.',
      icon: <BuildIcon />
    },
    {
      title: 'Deployment',
      date: 'Q3 2025',
      description: 'Full scale deployment with subscription model monetization.',
      icon: <RocketLaunchIcon />
    },
  ];

  return (
    <Box mt={6} mb={4}>
      <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
        <EventIcon color="primary" sx={{ mr: 1 }} />
        <Typography variant="h5" align="center">
          Roadmap
        </Typography>
      </Box>

      <Timeline sx={{ px: isMobile ? 0 : '', [`& .${timelineOppositeContentClasses.root}`]: isMobile ? {
          flex: 0.2,
        } : '' }} position={isMobile ? 'right' : 'alternate'}>
        {roadmap.map((item, index) => (
          <TimelineItem key={index}>
            <TimelineOppositeContent
              sx={{ m: 'auto 0' }}
              align="right"
              variant="body2"
              color="text.secondary"
            >
              {item.date}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot color="primary" variant="outlined">
                {item.icon}
              </TimelineDot>
              {index < roadmap.length - 1 && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  borderColor: 'primary.main',
                  backgroundColor: theme.palette.background.default
                }}
              >
                <Typography variant="h6" component="span">
                  {item.title}
                </Typography>
                <Typography variant="body2">{item.description}</Typography>
              </Paper>
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </Box>
  );
}
